import loaded from "@/scripts/helpers/loaded.js";

const selectors = {
    video: '[data-video]'
};

const classes = {
    loaded: 'video--loaded'
};

const settings = {
    loaded(video) {
        const autoplay = video?.dataset?.autoplay;

        video?.classList?.add(classes?.loaded);

        if (typeof autoplay === "undefined") {
            return;
        }

        video?.setAttribute("autoplay", true);
        video?.play();
    },
};

loaded( async () => {
    const videos = document.querySelectorAll(selectors?.video);
    if (!videos) {
        return;
    }

    if (!videos?.length) {
        return;
    }

    const { default: lozad } = await import('lozad');
    if (!lozad) {
        return;
    }

    try {
        const observer = lozad(selectors?.video, settings);
        if (!observer) {
            return;
        }

        observer?.observe();

        const mutationObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation?.type !== 'childList') {
                    return;
                }

                const addedNodes = mutation?.addedNodes;
                if (!addedNodes) {
                    return;
                }

                if (!addedNodes?.length) {
                    return;
                }

                addedNodes?.forEach((node) => {
                    if (node?.nodeType !== 1) {
                        return;
                    }

                    if (!!node?.matches(selectors?.video)) {
                        // New `.lozad` element added, observe it with Lozad
                        observer?.triggerLoad(node);

                        observer.observe(node, settings);

                        return;
                    }

                    const elements = Array.from(node?.querySelectorAll(selectors?.video));
                    if (!elements) {
                        return;
                    }

                    if (!elements?.length) {
                        return;
                    }

                    elements?.forEach((element) => {
                        observer?.triggerLoad(element);

                        observer?.observe(element, settings);
                    });
                });
            }
        });

        mutationObserver?.observe(document.body, {
            childList: true,
            subtree: true,
        });
    } catch (error) {
    }
});
